import i18n from "../lang/i18n";
const parameterValidations = {
  name: {
    required: true,
    maxLength: 255
  },
  weight: {
    required: true,
    format: {
      valid: value => /^((100)|(\d{1,4}(\.\d*)?))$/.test(value.trim()),
      message: i18n.t("validation.the_weight_must_be_number_from_0_to_100")
    }
  },
  maxPoint: {
    required: true,
    format: {
      valid: value => /^((10000)|(\d{1,4}(\.\d*)?))$/.test(value),
      message: i18n.t("validation.the_max_point_must_be_number_from_0_to_10000")
    }
  },
  communicationDetail: {
    required: true
  },
  responseFromParent: {
    required: true
  }
};
export { parameterValidations };
